import React, { useState, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";
import BASE_API_URL from "../../../apis/index";
import Divider from "@mui/material/Divider";
import { Link } from "react-router-dom";

export default function AdminCompanySearchBar() {
  const [search, setSearch] = useState("");
  const [filterType, setFilterType] = useState("All");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchSuggestions = async (query, type = "All") => {
    if (!query.trim()) {
      setSuggestions([]);
      return;
    }

    try {
      setLoading(true);
      const authToken = localStorage.getItem("authToken");
      const res = await axios.get(`${BASE_API_URL}/api/admin/search/companies`, {
        headers: { Authorization: `Bearer ${authToken}` },
        params: { search: query, type },
      });

      setSuggestions(res.data || []);

    } catch (err) {
      console.error("Error fetching suggestions:", err);
      setSuggestions([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    fetchSuggestions(search.trim(), filterType);
    setShowSuggestions(false);
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchSuggestions(search, filterType);
      setShowSuggestions(true);
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [search, filterType]);

  return (
    <Wrapper>
      <SearchBarRow>
        <div className="d-flex SearchBar">
          <SearchInput
            type="text"
            placeholder="Search Company"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onFocus={() => search && setShowSuggestions(true)}
            // onBlur={() => setTimeout(() => setShowSuggestions(false), 150)}
            // onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />

          <Divider orientation="vertical" flexItem />

          <FilterSelect
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
          >
            <option value="All">All</option>
            <option value="Companies">Companies</option>
            <option value="Products">Products</option>
            <option value="Services">Services</option>
          </FilterSelect>

          <SearchBtn onClick={handleSearch}>Search</SearchBtn>
        </div>
        {/* Dropdown Suggestions */}
        {showSuggestions && suggestions.length > 0 && (
          <SuggestionsBox>
            {suggestions.map((item, index) => (
              <SuggestionRow key={index}>
                <Link
                  to={`/admin/company-details?compId=${item.id}`}
                  className="w-100 d-flex align-items-center text-decoration-none"
                  style={{ color: "inherit" }}
                >
                  <img
                    src={`${BASE_API_URL}/uploads/user_comp_docs/${item.company_logo}`}
                    onError={(e) => (e.target.style.display = "none")}
                    alt={`company logo ${item.company_name}`}
                  />
                  <span className="ms-3">{item.company_name}</span>
                </Link>
              </SuggestionRow>
            ))}
          </SuggestionsBox>
        )}

        {loading && <LoadingText>Loading...</LoadingText>}
      </SearchBarRow>

    </Wrapper>
  );
}


// ============================ Styled Components ============================

const Wrapper = styled.div`
  position: relative;
  width: 750px;
`;

const SearchBarRow = styled.div`
  position: relative;
  width: 100%;
  position: relative;
  div.SearchBar {
    display: flex;
    box-shadow: 0 25px 60px rgba(113, 106, 147, .15);
    padding: 10px;
    border-radius: 10px;
    background: #fff;
    border: 2px solid #dfdfdfff;
  }
`;

const SearchInput = styled.input`
  width: 450px;
  padding: 10.5px 20px;
  border: none !important;
  outline: none;
  font-size: 1rem;
  color: var(--primary-color);
`;

const FilterSelect = styled.select`
  padding: 12px 16px;
  border: 1px solid white !important;
  background: var(--white-color);
  color: var(--primary-color);
  margin-right: 20px;
  outline: none;
  font-size: 1rem;
`;

const SearchBtn = styled.button`
  background: linear-gradient(90deg, var(--secondary-color), var(--primary-color));
  border: none;
  padding: 12px 25px;
  border-radius: 6px;
  color: white;
  font-weight: 500;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;

const SuggestionsBox = styled.div`
  position: absolute;
  top: 75px;
  z-index: 20;
  width: 100%;
  background: white;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 20px 40px rgba(0,0,0,.1);
  max-height: 450px;
  overflow-y: auto;
`;

const SuggestionRow = styled.div`
  display: flex;
  align-items: center;
  padding: 15px;
  gap: 12px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  transition: background 0.15s;
  &:hover {
    background: #f8f8f8;
  }

  img {
    width: 34px;
    height: 34px;
    object-fit: contain;
    border-radius: 6px;
    background: #fafafa;
  }

  span {
    font-size: 0.95rem;
    color: #333;
    font-weight: 500;
  }
`;

const LoadingText = styled.div`
  margin-top: 8px;
  font-size: 14px;
  color: gray;
`;

